import { getEnv } from 'common-nextjs';

/**
 * Reddit Pixel script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: RedditScript.tsx
 */
export function setupRedditLocalCapture() {
  if (window.rdt) return;

  // Based on original Reddit pixel code structure
  // prettier-ignore
  const p = window.rdt = function () {
    if (getEnv() !== 'production') {
      console.log(
        '[Reddit Local] rdt called with args:',
        Array.prototype.slice.call(arguments, 0),
      );
    }
    // @ts-ignore
    p.sendEvent ? p.sendEvent.apply(p, arguments) : p.callQueue.push(arguments);
  };

  // @ts-ignore
  p.callQueue = [];

  // @ts-ignore
  p('init', 'a2_frqgko7x8vzz');
}
